/* HARDEN landing: light scroll reveal, the Original/HARDEN demo switch, the hero animation, the persistent Add to cart bar.
   Loaded with defer by the hero section; guarded so a second tag does nothing. No dependencies, the open demo tab's two small MP3 files load when the section nears the screen. */
(function () {
  'use strict';
  if (window.__hdLanding) return;
  window.__hdLanding = 1;

  var doc = document;
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var hasIO = 'IntersectionObserver' in window;

  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('sample_agency:' + name, data || {});
      }
    } catch (e) {}
  }
  function ready(fn) {
    if (doc.readyState !== 'loading') fn(); else doc.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    doc.documentElement.classList.add('hd-js');

    /* reveal on scroll */
    var rv = [].slice.call(doc.querySelectorAll('.hd-rv'));
    if (!hasIO || reduce) {
      rv.forEach(function (e) { e.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -4% 0px', threshold: 0.05 });
      rv.forEach(function (e) { io.observe(e); });
    }

    /* Original / HARDEN switch: both files of a tab play in sync (Web Audio), the switch only moves the volume between them
       (a few ms of crossfade), so it changes on the fly with no gap and no restart. The open tab's two files load when the
       section nears the screen, the other tabs on their first click; nothing is audible before Play. */
    var stopAudio = function () {};
    [].slice.call(doc.querySelectorAll('[data-hd-ab2]')).forEach(function (root) {
      var AC = window.AudioContext || window.webkitAudioContext;
      var tabs = [].slice.call(root.querySelectorAll('.hd-ab2__tab'));
      var wave = root.querySelector('[data-hd-wave]'), canvas = root.querySelector('[data-hd-canvas]');
      var head = root.querySelector('[data-hd-head]'), msg = root.querySelector('[data-hd-msg]');
      var line = root.querySelector('[data-hd-line]'), playBtn = root.querySelector('[data-hd-play]');
      var playTxt = root.querySelector('[data-hd-play-t]'), sw = root.querySelector('[data-hd-sw]');
      var swBtns = [].slice.call(sw.querySelectorAll('button'));
      if (!tabs.length || !canvas) return;

      var ctx = null, cache = {}, cur = tabs[0], side = 'before', playing = false;
      var pos = 0, t0 = 0, srcs = null, gains = null, raf = 0, token = 0, sent = {};
      var FADE = 0.002;   /* setTargetAtTime time constant: about 6 ms to settle, no click */

      var T = function (k, d) { return root.getAttribute('data-t-' + k) || d; };
      function say(t) { if (msg) msg.textContent = t || ''; root.classList.toggle('has-msg', !!t); }
      function getCtx() { if (!ctx && AC) { try { ctx = new AC(); } catch (e) { ctx = null; } } return ctx; }
      /* iPhone: Web Audio is muted by the ring/silent switch, a playing <audio> element is not. A silent loop plays with the demo
         (and audioSession 'playback' where Safari has it), so the demo is heard with the switch on silent too. */
      var keep = null;
      function keepAlive(on) {
        try { if (navigator.audioSession) navigator.audioSession.type = 'playback'; } catch (e) {}
        try {
          if (on) {
            if (!keep) {
              keep = doc.createElement('audio');
              keep.src = 'data:audio/wav;base64,UklGRl4RAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YToRAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=';
              keep.loop = true; keep.setAttribute('playsinline', ''); keep.setAttribute('aria-hidden', 'true'); keep.preload = 'auto';
            }
            var pr = keep.play(); if (pr && pr.catch) pr.catch(function () {});
          } else if (keep) { keep.pause(); }
        } catch (e) {}
      }
      function decode(buf) {
        return new Promise(function (ok, no) {
          var p = ctx.decodeAudioData(buf, ok, no);
          if (p && p.then) p.then(ok, no);
        });
      }
      function fetchBuf(url) {
        return fetch(url, { credentials: 'omit' }).then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          return r.arrayBuffer();
        }).then(decode);
      }
      function peaks(buf, n) {
        var out = new Float32Array(n), ch = buf.numberOfChannels, len = buf.length, step = Math.max(1, Math.floor(len / n));
        for (var c = 0; c < ch; c++) {
          var d = buf.getChannelData(c);
          for (var i = 0; i < n; i++) {
            var m = 0, from = i * step, to = Math.min(len, from + step);
            for (var j = from; j < to; j += 8) { var v = d[j] < 0 ? -d[j] : d[j]; if (v > m) m = v; }
            if (m > out[i]) out[i] = m;
          }
        }
        return out;
      }
      function load(tab) {
        var key = tab.getAttribute('data-before') + '|' + tab.getAttribute('data-after');
        if (cache[key]) return cache[key];
        if (!getCtx()) return Promise.reject(new Error('no audio'));
        var pr = Promise.all([fetchBuf(tab.getAttribute('data-before')), fetchBuf(tab.getAttribute('data-after'))]).then(function (b) {
          var n = 200, pa = peaks(b[0], n), pb = peaks(b[1], n), mx = 0.001;
          for (var i = 0; i < n; i++) { if (pa[i] > mx) mx = pa[i]; if (pb[i] > mx) mx = pb[i]; }
          for (i = 0; i < n; i++) { pa[i] /= mx; pb[i] /= mx; }
          return { before: b[0], after: b[1], pa: pa, pb: pb, dur: Math.min(b[0].duration, b[1].duration) };
        });
        cache[key] = pr;
        pr.catch(function () { delete cache[key]; });
        return pr;
      }

      var shown = null;   /* the loaded tab data the waveform shows */
      function draw() {
        var w = wave.clientWidth, h = wave.clientHeight, dpr = Math.min(2, window.devicePixelRatio || 1);
        if (!w || !h) return;
        if (canvas.width !== Math.round(w * dpr) || canvas.height !== Math.round(h * dpr)) { canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr); }
        var g = canvas.getContext('2d'); g.setTransform(dpr, 0, 0, dpr, 0, 0); g.clearRect(0, 0, w, h);
        var n = 200, bw = w / n, mid = h / 2, i;
        if (!shown) {
          g.fillStyle = 'rgba(214,220,232,.16)';
          for (i = 0; i < n; i++) g.fillRect(i * bw, mid - 1, Math.max(1, bw - 1), 2);
          return;
        }
        var layers = [['pa', 'rgba(214,220,232,', 'before'], ['pb', 'rgba(255,157,84,', 'after']];
        layers.forEach(function (l) {
          var on = side === l[2];
          g.fillStyle = l[1] + (on ? '.95)' : '.20)');
          var arr = shown[l[0]];
          for (i = 0; i < n; i++) {
            var hh = Math.max(2, arr[i] * (h - 8));
            g.fillRect(i * bw, mid - hh / 2, Math.max(1, bw - 1), hh);
          }
        });
      }
      function position() {
        if (!shown) return 0;
        if (!playing) return pos;
        var d = shown.dur, t = (ctx.currentTime - t0) % d;
        return t < 0 ? t + d : t;
      }
      function paint() {
        var d = shown ? shown.dur : 1, r = Math.min(1, position() / d);
        head.style.transform = 'translateX(' + (r * wave.clientWidth) + 'px)';
        wave.setAttribute('aria-valuenow', String(Math.round(r * 100)));
        wave.setAttribute('aria-valuetext', shown ? (r * d).toFixed(1) + ' / ' + d.toFixed(1) + ' s' : '0 s');
        if (playing) raf = requestAnimationFrame(paint);
      }
      function setPlayUi(on) {
        playing = on;
        playTxt.textContent = on ? T('pause', 'Pause') : T('play', 'Play');
        if (!on) keepAlive(false);
        root.classList.toggle('is-playing', on);
        cancelAnimationFrame(raf);
        paint();
      }
      function killSources() {
        if (srcs) { srcs.forEach(function (s) { try { s.stop(); } catch (e) {} try { s.disconnect(); } catch (e) {} }); }
        srcs = null; gains = null;
      }
      function applyGains(quick) {
        if (!gains) return;
        var now = ctx.currentTime, tc = quick ? 0.001 : FADE;
        gains[0].gain.setTargetAtTime(side === 'before' ? 1 : 0, now, tc);
        gains[1].gain.setTargetAtTime(side === 'after' ? 1 : 0, now, tc);
      }
      function startAt(off) {
        killSources();
        var d = shown;
        var when = ctx.currentTime + 0.03;
        gains = [ctx.createGain(), ctx.createGain()];
        srcs = [d.before, d.after].map(function (b, i) {
          var s = ctx.createBufferSource(); s.buffer = b; s.loop = true;
          s.connect(gains[i]); gains[i].connect(ctx.destination);
          s.start(when, off % b.duration);
          return s;
        });
        gains[0].gain.value = side === 'before' ? 1 : 0;
        gains[1].gain.value = side === 'after' ? 1 : 0;
        t0 = when - off;
        setPlayUi(true);
      }
      function pause() {
        if (!playing) return;
        pos = position();
        killSources();
        setPlayUi(false);
      }
      function play() {
        if (!getCtx()) { say(T('noaudio', 'Your browser cannot play this demo.')); return; }
        if (ctx.state !== 'running' && ctx.resume) ctx.resume();
        keepAlive(true);
        var my = ++token;
        say(T('loading', 'Loading...'));
        load(cur).then(function (d) {
          if (my !== token) return;
          say('');
          shown = d; draw();
          root.classList.add('is-played');
          startAt(pos);
          if (!sent['p' + cur.getAttribute('data-mode')]) {
            sent['p' + cur.getAttribute('data-mode')] = 1;
            track('harden_demo_play', { mode: cur.getAttribute('data-mode') || '' });
          }
        }).catch(function () { if (my === token) say(T('err', 'The audio could not be loaded. Please try again.')); });
      }
      stopAudio = function () { ++token; if (playing) pause(); };

      function setSide(s) {
        side = s;
        sw.setAttribute('data-side', s);
        swBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-side') === s ? 'true' : 'false'); });
        root.setAttribute('data-side', s);
        applyGains(false);
        draw();
        var k = 's' + cur.getAttribute('data-mode') + s;
        if (playing && !sent[k]) { sent[k] = 1; track('harden_demo_switch', { mode: cur.getAttribute('data-mode') || '', side: s }); }
      }
      function setTab(tab) {
        if (tab === cur) return;
        var was = playing;
        ++token;
        if (playing) { killSources(); setPlayUi(false); }
        cur = tab; pos = 0; shown = null;
        tabs.forEach(function (t) { t.setAttribute('aria-pressed', t === tab ? 'true' : 'false'); });
        line.textContent = tab.getAttribute('data-line') || '';
        draw(); paint();
        if (was) { play(); } else if (getCtx()) {
          var my = token;
          load(tab).then(function (d) { if (my === token) { shown = d; draw(); } }).catch(function () {});
        }
      }
      function seek(r) {
        r = Math.max(0, Math.min(0.999, r));
        if (!shown) return;
        pos = r * shown.dur;
        if (playing) startAt(pos); else paint();
      }

      tabs.forEach(function (t) { t.addEventListener('click', function () { setTab(t); }); });
      swBtns.forEach(function (b) { b.addEventListener('click', function () { setSide(b.getAttribute('data-side')); }); });
      playBtn.addEventListener('click', function () { if (playing) pause(); else play(); });
      wave.addEventListener('pointerdown', function (e) {
        var r = wave.getBoundingClientRect();
        seek((e.clientX - r.left) / r.width);
      });
      wave.addEventListener('keydown', function (e) {
        var k = e.key;
        if (k === ' ' || k === 'Enter') { e.preventDefault(); if (playing) pause(); else play(); }
        else if (shown && (k === 'ArrowRight' || k === 'ArrowLeft')) { e.preventDefault(); seek(position() / shown.dur + (k === 'ArrowRight' ? 0.05 : -0.05)); }
      });
      window.addEventListener('resize', function () { draw(); paint(); });
      doc.addEventListener('visibilitychange', function () { if (doc.hidden && playing) pause(); });
      draw();

      /* load the open tab when the section nears the screen, so the waveform is there before the first press */
      var armed = false;
      function arm() {
        if (armed) return; armed = true;
        if (!getCtx()) return;
        var my = token;
        load(cur).then(function (d) { if (my === token && !shown) { shown = d; draw(); } }).catch(function () {});
      }
      if (hasIO) {
        var io2 = new IntersectionObserver(function (es) {
          if (es.some(function (e) { return e.isIntersecting; })) { arm(); io2.disconnect(); }
        }, { rootMargin: '400px 0px' });
        io2.observe(root);
      } else { arm(); }
    });
    /* Hero animation: a muted looping MP4 laid over the screenshot once the page has loaded. The screenshot stays the first paint (nothing waits for the
       video). Skipped for reduced motion, data saver and 2G; the small file for phones; paused while off screen or in a hidden tab. */
    (function () {
      var fig = doc.querySelector('.hd-hero__shot[data-hd-vid-d]');
      if (!fig || reduce) return;
      var du = fig.getAttribute('data-hd-vid-d'), mu = fig.getAttribute('data-hd-vid-m');
      var conn = navigator.connection || {};
      if (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) return;
      var mobile = false;
      try { mobile = window.matchMedia('(max-width: 749px)').matches; } catch (e) {}
      var src = (mobile ? mu : du) || du || mu;
      if (!src) return;
      var v = null;
      function play() { if (!v) return; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      function start() {
        if (v) return;
        v = doc.createElement('video');
        v.className = 'hd-hero__vid';
        v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true; v.preload = 'auto';
        v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true'); v.tabIndex = -1;
        v.disablePictureInPicture = true;
        v.addEventListener('playing', function () { fig.classList.add('is-vid'); }, { once: true });
        v.addEventListener('error', function () { if (v && v.parentNode) v.parentNode.removeChild(v); v = null; });
        v.src = src;
        fig.appendChild(v);
        play();
      }
      function whenIdle() {
        if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 2500 }); else setTimeout(start, 800);
      }
      if (doc.readyState === 'complete') whenIdle(); else window.addEventListener('load', whenIdle, { once: true });
      if (hasIO) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (!v) return; if (e.isIntersecting) play(); else v.pause(); });
        }, { threshold: 0.05 }).observe(fig);
      }
      doc.addEventListener('visibilitychange', function () { if (!v) return; if (doc.hidden) v.pause(); else play(); });
    })();
    /* persistent Add to cart bar: proxies the real Add to cart (same flow as the hero button), see snippets/harden-sticky.liquid */
    (function () {
      var bar = doc.getElementById('hd-stk');
      if (!bar || bar.getAttribute('data-init')) return;
      bar.setAttribute('data-init', '1');
      var btn = bar.querySelector('[data-hd-stk-btn]');
      if (!btn) return;
      doc.body.appendChild(bar);  /* position: fixed must not live inside a transformed ancestor */

      function realButtons() { return [].slice.call(doc.querySelectorAll('.hd .product-form__submit')); }
      function realAtc() {
        var l = realButtons();
        for (var i = 0; i < l.length; i++) { if (l[i].offsetParent !== null) return l[i]; }
        return l[0] || null;
      }
      function sync() {
        var r = realAtc();
        if (!r) return;
        btn.disabled = r.hasAttribute('disabled') || r.getAttribute('aria-disabled') === 'true';
        var lbl = r.querySelector('span');
        if (lbl && lbl.textContent.trim()) btn.textContent = lbl.textContent.trim();
      }
      sync();
      var r0 = realAtc();
      if (r0 && 'MutationObserver' in window) {
        new MutationObserver(sync).observe(r0, { attributes: true, childList: true, subtree: true });
      }
      btn.addEventListener('click', function () {
        var b = realAtc();
        if (!b) return;
        if (b.hasAttribute('disabled')) {
          var w = doc.querySelector('[data-cro-waiver]');
          if (w) {
            w.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
            w.classList.add('hd-waiver--flash');
            setTimeout(function () { w.classList.remove('hd-waiver--flash'); }, 1600);
          }
          return;
        }
        b.click();
        track('harden_sticky_atc', {});
      });

      /* above the cookie banner while it is visible */
      var cc = doc.getElementById('cro-cookie-consent');
      function lift() {
        var on = !!(cc && cc.isConnected && cc.classList.contains('is-visible'));
        bar.style.bottom = on ? (Math.max(0, Math.floor(cc.getBoundingClientRect().height) - 1) + 'px') : '';
        bar.classList.toggle('is-lifted', on);
      }
      if (cc) {
        lift();
        if ('MutationObserver' in window) new MutationObserver(lift).observe(cc, { attributes: true, attributeFilter: ['class'] });
        if ('ResizeObserver' in window) new ResizeObserver(lift).observe(cc);
        window.addEventListener('resize', lift);
      }

      /* show only when the hero buy button has scrolled out above the viewport, no buy button is on screen,
         and the closing CTA has not started to enter */
      var ticking = false;
      function update() {
        ticking = false;
        var vh = window.innerHeight || doc.documentElement.clientHeight;
        var l = realButtons();
        if (!l.length) { bar.classList.remove('is-on'); return; }
        var past = l[0].getBoundingClientRect().bottom < 0;
        var inView = l.some(function (b) {
          var r = b.getBoundingClientRect();
          return r.bottom > 0 && r.top < vh;
        });
        var cta = doc.getElementById('hd-cta');
        var atEnd = cta ? cta.getBoundingClientRect().top < vh : false;
        var show = past && !inView && !atEnd;
        bar.classList.toggle('is-on', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
      function queue() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      update();
    })();
  });
})();
